import { render, staticRenderFns } from "./AnonymousUserNotifyModal.vue?vue&type=template&id=612c54fa&"
import script from "./AnonymousUserNotifyModal.vue?vue&type=script&lang=ts&"
export * from "./AnonymousUserNotifyModal.vue?vue&type=script&lang=ts&"
import style0 from "./AnonymousUserNotifyModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports